<template>
  <div class="home">
    <div class="container">
      <div class="content">
        <p class="payment">{{ $t("paymentType") }} : {{ pay["name"] }}</p>
        <ul class="tab-list">
          <li :class="{ active: this.tabIndex === 0 }" @click="handleTap(0)">
            <!-- 元宝/各种卡 -->
            {{ $t("card") }}
          </li>
          <li :class="{ active: this.tabIndex === 1 }" @click="handleTap(1)">
            <!-- 礼包 -->
            {{ $t("gift") }}
          </li>
        </ul>
        <div class="form-container">
          <Form
            ref="form"
            :model="form"
            :rules="rules"
            :label-width="labelWidth"
          >
            <FormItem :label="$t('characterId')" prop="id">
              <Input
                class="first"
                v-model="form.id"
                :size="size"
                placeholder="Enter something..."
                @input="handleIdChange"
              />
              <div
                class="yiwen-ico"
                @mouseover="tipsShow = true"
                @mouseout="tipsShow = false"
              ></div>
              <div
                class="confirm-btn"
                :class="{ active: canConfirm }"
                @click="confirmCharacterId"
              >
                confirm
              </div>
              <div class="tips" v-show="tipsShow">
                <img src="@/assets/help.png" alt="" />
              </div>
            </FormItem>
            <FormItem :label="$t('characterName')" prop="nama">
              <Input
                v-model="form.nama"
                :size="size"
                :style="{ width: width }"
                disabled
              />
            </FormItem>
            <FormItem :label="$t('server')" prop="server">
              <Input
                v-model="form.server"
                :size="size"
                :style="{ width: width }"
                disabled
              />
            </FormItem>
            <FormItem :label="$t('selectItem')" prop="item">
              <Select
                v-model="form.item"
                clearable
                :size="size"
                :style="{ width: width }"
                placeholder="please select..."
              >
                <Option
                  v-for="(item, index) in productList"
                  :key="index"
                  :value="`${item.item}|${item.lcoin}`"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Form>
          <div class="button-wrap" @click="submitRecharge">
            {{ $t("rechargeBtn") }}
          </div>
        </div>
        <div class="pay-intrduce">
          <p v-html="introduce"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkCharacterId,
  rechargeRecess,
  getProductItems
} from "@/api/recharge";
import { paramToFormData } from "@/utils";
import Cookies from "js-cookie";
export default {
  name: "pay",
  data() {
    const validateId = (rule, value, callback) => {
      if (!/^[0-9]*$/.test(parseInt(value))) {
        callback(new Error(this.$t("errorCharacterId")));
      } else {
        callback();
      }
    };
    return {
      isConfirm: true,
      tabIndex: 0,
      tipsShow: false,
      clientWidth: 0,
      width: "",
      labelWidth: 0,
      size: "large",
      pay: {},
      areaMap: {
        1: "2",
        2: "3",
        3: "1"
      },
      areaId: -1,
      introduce: this.$t("introduce"),
      productList: [],
      form: {
        id: "",
        nama: "",
        server: "",
        item: "",
        userId: ""
      },
      rules: {
        id: [{ required: true, validator: validateId, trigger: "blur" }],
        nama: [
          {
            required: true,
            message: this.$t("errorCharacterName"),
            trigger: "change"
          }
        ],
        server: [
          {
            required: true,
            type: "number",
            message: this.$t("errorServer"),
            trigger: "change"
          }
        ],
        item: [
          {
            required: true,
            message: this.$t("errorSelectItem"),
            trigger: "change"
          }
        ]
      }
    };
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.params.pay)
      next(vm => {
        vm.pay = to.params.pay;
        vm.areaId = vm.areaMap[to.params.areaId];
      });
    else {
      next("/");
    }
  },
  computed: {
    styleWidth() {
      return {
        width: "432px"
      };
    },
    canConfirm() {
      return this.form.id && this.isConfirm;
    }
  },
  watch: {
    clientWidth: {
      handler(val) {
        if (val > 960) {
          this.width = "432px";
          this.labelWidth = 127;
          this.size = "large";
        } else {
          this.width = "96%";
          this.labelWidth = 100;
          this.size = "default";
        }
      },
      immediate: true
    }
  },
  created() {
    this.initWidth();
    window.addEventListener("resize", this.initWidth);
  },
  methods: {
    // 检查role id
    confirmCharacterId() {
      if (!this.canConfirm) {
        this.$Message.warning(this.$t("inputRoleId")); // 请输入角色id或者重新输入
        return;
      }
      this.$refs.form.validateField("id", async valid => {
        if (!valid) {
          this.isConfirm = false;
          const params = paramToFormData({
            roleId: this.form.id,
            productId: "621001"
          });
          const { code, data: user = {} } = await checkCharacterId(params);
          if (code === 0) {
            this.form.nama = user.roleName || "";
            this.form.server = user.serverId || "";
            this.form.userId = user.userId;
            await this.getProductItems(this.tabIndex);
          } else {
            this.$Message.error(this.$t("noRoleId")); // 您输入的角色不存在，请重新输入！
          }
        }
      });
    },
    // 提交充值
    submitRecharge() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const params = paramToFormData({
            pid: "621001",
            sid: this.form.server,
            cid: this.pay.cid,
            areaId: this.areaId,
            roleId: this.form.id,
            item: this.form.item && this.form.item.split("|")[0],
            lcoins: this.form.item && this.form.item.split("|")[1],
            userId: this.form.userId,
            payFrom: "pc"
          });
          const { data } = await rechargeRecess(params);
          if (data.url) {
            window.location.href = data.url;
          } else {
            const {
              request_url,
              merchantId,
              trxDateTime,
              channelId,
              amount,
              currency,
              returnUrl,
              sign,
              trxId
            } = data;
            const form = `
                  <form name="gocPayfrm" method="post" action="${request_url}">
                    <input type="submit" value="Submit">
                    <input type="hidden" name="merchantId" value="${merchantId}">
                    <input type="hidden" name="trxId" value="${trxId}">
                    <input type="hidden" name="trxDateTime" value="${trxDateTime}">
                    <input type="hidden" name="channelId" value="${channelId}">
                    <input type="hidden" name="amount" value="${amount}">
                    <input type="hidden" name="currency" value="${currency}">
                    <input type="hidden" name="returnUrl" value="${returnUrl}">
                    <input type="hidden" name="sign" value="${sign}">
                </form>
            `;
            const formDom = this.parseDom(form);
            document.body.appendChild(formDom).submit();
            // form.appendTo("body").submit();
          }
          if (window.location.href.indexOf("pcpay") > -1) {
            Cookies.set("platform", "pc");
          }
        } else {
          this.$Message.error(this.$t("supplementAllInfo")); // 请补全完整的信息！
        }
      });
    },
    // 获取 select items
    async getProductItems(type) {
      const params = paramToFormData({
        roleId: this.form.id,
        productId: "621001",
        userId: this.form.userId,
        type
      });
      const { data: data = {} } = await getProductItems(params);
      this.productList = Object.values(data);
    },
    handleIdChange() {
      this.isConfirm = true;
    },
    async handleTap(index) {
      this.tabIndex = index;
      await this.getProductItems(this.tabIndex);
    },
    initWidth() {
      this.clientWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
    },
    parseDom(arg) {
      var objE = document.createElement("div");
      objE.innerHTML = arg;
      return [].filter.call(objE.childNodes, item => {
        return item.nodeType !== 3;
      })[0];
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.initWidth);
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 961px) {
  .container {
    width: 1177px;
    min-height: 744px;
    background: url(~@/assets/border-bg.png) no-repeat left top / 100% 100%;
    margin: 594px auto 100px auto;
    padding: 45px 45px 50px 45px;
    box-sizing: border-box;
    .content {
      width: 100%;
      min-height: 872px;
      background: url(~@/assets/inner-bg.jpg) no-repeat left top / 100% 100%;
      padding: 64px 50px;
      box-sizing: border-box;
      padding: 50px 160px 124px 160px;
      box-sizing: border-box;
      p.payment {
        font-size: 18px;
        color: #333;
        widows: 100%;
        text-align: center;
        padding-bottom: 30px;
      }
      .tab-list {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        > li {
          width: 224px;
          height: 52px;
          color: #fff;
          font-size: 18px;
          line-height: 52px;
          text-align: center;
          cursor: pointer;
          background: url(~@/assets/button-bg.png) no-repeat left top / 100%
            100%;
          &:nth-child(2) {
            margin-left: 42px;
          }
          &:hover,
          &.active {
            background: url(~@/assets/button-bg-active.png) no-repeat left top /
              100% 100%;
          }
        }
      }
      .form-container {
        width: 712px;
        margin: 0 auto;
        padding-top: 52px;
        font-size: 14px;
        .yiwen-ico {
          width: 30px;
          height: 30px;
          background: url(~@/assets/yiwen-ico.png) left center / 100% 100%;
          display: inline-block;
          vertical-align: middle;
          margin-left: 10px;
          cursor: pointer;
        }
        .confirm-btn {
          width: 78px;
          height: 30px;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
          display: inline-block;
          color: #fff;
          border-radius: 4px;
          background: #989898;
          margin-left: 12px;
          vertical-align: middle;
          &.active {
            background: #ca9e53;
          }
        }
        .button-wrap {
          width: 282px;
          height: 51px;
          background: url(~@/assets/recharge.png) no-repeat left center;
          margin: 40px auto;
          cursor: pointer;
          color: #fff;
          text-align: center;
          line-height: 50px;
          font-weight: bold;
          font-size: 18px;
          &:hover {
            background: url(~@/assets/recharge-active.png);
          }
        }
        .tips {
          position: absolute;
          z-index: 999;
          right: -53px;
          top: 43px;
          width: 362px;
          height: 222px;
          border-radius: 5px;
          background: rgba(0, 0, 0, 0.3);
          &:after {
            position: absolute;
            content: "";
            display: block;
            width: 0;
            height: 0;
            left: 50%;
            top: -20px;
            margin-left: -10px;
            border-width: 10px;
            border-style: solid;
            border-color: transparent transparent rgba(0, 0, 0, 0.3) transparent;
          }
          > img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
          }
        }
        /deep/ .ivu-input-wrapper.first {
          width: 432px;
        }
      }
      .pay-intrduce {
        color: #848484;
        line-height: 2;
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .container {
    width: 96%;
    min-height: 500px;
    background: url(~@/assets/border-bg-mobile.png) no-repeat left top / 100%
      100%;
    margin: 200px auto 100px auto;
    padding: 15px 10px 15px 10px;
    box-sizing: border-box;
    .content {
      width: 100%;
      min-height: 566px;
      background: url(~@/assets/inner-bg-mobile.jpg) no-repeat left top / 100%
        100%;
      padding: 16px 0;
      box-sizing: border-box;
      p.payment {
        font-size: 14px;
        color: #333;
        widows: 100%;
        text-align: center;
        padding-bottom: 30px;
        font-weight: bold;
      }
      .tab-list {
        width: 96%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        > li {
          width: 140px;
          height: 38px;
          color: #fff;
          font-size: 16px;
          line-height: 38px;
          text-align: center;
          cursor: pointer;
          background: url(~@/assets/button-bg.png) no-repeat left top / 100%
            100%;
          &:nth-child(2) {
            margin-left: 42px;
          }
          &:hover,
          &.active {
            background: url(~@/assets/button-bg-active.png) no-repeat left top /
              100% 100%;
          }
        }
      }
      .form-container {
        width: 100%;
        margin: 0 auto;
        padding-top: 52px;
        font-size: 14px;
        position: relative;
        .yiwen-ico {
          width: 20px;
          height: 20px;
          background: url(~@/assets/yiwen-ico.png) left center / 100% 100%;
          display: inline-block;
          vertical-align: middle;
          margin-left: 5px;
          cursor: pointer;
        }
        .confirm-btn {
          width: 58px;
          height: 24px;
          font-size: 12px;
          line-height: 24px;
          text-align: center;
          cursor: pointer;
          display: inline-block;
          color: #fff;
          border-radius: 2px;
          background: #989898;
          margin-left: 8px;
          vertical-align: middle;
          &:hover,
          &.active {
            background: #ca9e53;
          }
        }
        .button-wrap {
          width: 200px;
          height: 40px;
          background: url(~@/assets/recharge.png) no-repeat left center / 100%
            100%;
          margin: 30px auto;
          color: #fff;
          text-align: center;
          line-height: 40px;
          font-weight: bold;
          cursor: pointer;
          &:hover {
            background: url(~@/assets/recharge-active.png) no-repeat left center /
              100% 100%;
          }
        }
        .tips {
          position: absolute;
          z-index: 999;
          right: 0px;
          top: 43px;
          width: 180px;
          height: 100px;
          border-radius: 5px;
          background: rgba(0, 0, 0, 0.3);
          &:after {
            position: absolute;
            content: "";
            display: block;
            width: 0;
            height: 0;
            left: 50%;
            top: -20px;
            margin-left: -10px;
            border-width: 10px;
            border-style: solid;
            border-color: transparent transparent rgba(0, 0, 0, 0.3) transparent;
          }
          > img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
          }
        }
      }
      .pay-intrduce {
        color: #848484;
        line-height: 2;
        padding: 0 10px;
      }
    }
  }
  /deep/ .ivu-form .ivu-form-item-label {
    padding-right: 5px;
  }
  /deep/ .ivu-form-item {
    margin-bottom: 16px;
  }
  /deep/ .ivu-input-wrapper.first {
    width: 57%;
  }
}
</style>
